import { forwardRef } from "react";

import { useParseTranslationString } from "@/hooks/useParseTranslationString";
import { fastLinkButtonVariants } from "@fastFields/fastLinkButton/variants";
import { LinkButton } from "@molecules/linkButton";

import type { IFastLinkButtonProps } from "@fastFields/fastLinkButton/types";

export const FastLinkButton = forwardRef<
  HTMLButtonElement,
  IFastLinkButtonProps
>(({ type, label: propsLabel, ...restButtonProps }, ref) => {
  const { parseTranslatableString } = useParseTranslationString([
    "action",
    "common",
    "page",
    "entity",
  ] as const);

  const { label: variantsLabel, ...variantProps } =
    fastLinkButtonVariants[type];

  const label = propsLabel || variantsLabel;

  return (
    <LinkButton
      label={parseTranslatableString(label)}
      {...variantProps}
      {...restButtonProps}
      ref={ref}
    />
  );
});

FastLinkButton.displayName = "FastLinkButton";
